import React from 'react';

const StatusCellRenderer = ({value}) => {
    const status = value?.toUpperCase();

    return (
        <>
            {status === "ABERTO" && <div className="text-[13px] well-status well danger">Pendente suporte</div>}
            {status === "CLIENTE" && <div className="text-[13px] well-status well warning">Pendente cliente</div>}
            {status === "BLOQUEIO" && <div className="text-[13px] well-status well blocked">Pendente comercial</div>}
            {status === "SOLUCIONADO" && <div className="text-[13px] well-status well well-status-open">Encerrado (solucionado)</div>}
            {status === "ENCERRADO" && <div className="text-[13px] well-status well-status-close">Encerrado (sem solução)</div>}
        </>
    );
};

export default StatusCellRenderer;